import { FC } from 'react';
import { TemplateType } from '@apply/constants';
import Popup from 'devextreme-react/popup';

type PreviewModalProps = {
    isOpen: boolean;
    onClose: () => void;
    templateTypeId: TemplateType;
    previewHtml: string;
    altContact: string;
    altCompany: string;
    altAddress: string;
};

export const PreviewModal: FC<PreviewModalProps> = ({
    isOpen,
    onClose,
    templateTypeId,
    previewHtml,
    altContact,
    altCompany,
    altAddress,
}) => {
    const styles = {
        iFrame: {
            border: '1px solid silver',
            borderRadius: '5px',
            width: '100%',
            height: '60vh',
            padding: '10px',
            margin: '5px',
        },
        warning: {
            border: '1px solid silver',
            borderRadius: '5px',
            padding: '10px',

            color: 'darkred',
            fontSize: 'smaller',
            margin: '5px',
            marginTop: '10px',
        },
    };

    const popupHiding = () => {
        onClose && onClose();
    };

    return (
        <Popup
            showTitle={true}
            title='Template Preview'
            visible={isOpen}
            onHiding={popupHiding}
            showCloseButton={true}
            width={1200}
        >
            {templateTypeId === TemplateType.Notices && (
                <div style={styles.warning}>
                    <p>
                        *Note: Preview shows the Contact, Company and Address for LOC loans. Non-LOC loans will use the following:
                    </p>
                    <table>
                        <tr>
                            <td style={{ width: '170px' }}>Creditor's Contact Name: </td>
                            <td>
                                <b>{altContact}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>Company Name: </td>
                            <td>
                                <b>{altCompany}</b>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ verticalAlign: 'top' }}>Address:</td>
                            <td>
                                <b>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: altAddress,
                                        }}
                                    ></span>
                                </b>
                            </td>
                        </tr>
                    </table>
                </div>
            )}
            <iframe
                title='agreementIframe'
                src={`data:text/html,${encodeURIComponent(previewHtml)}`}
                style={styles.iFrame}
            />
        </Popup>
    );
};
